import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { AuthService } from "../auth.service";
import { Router, RouterLink } from "@angular/router";
import { Subscription } from "rxjs";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FooterComponent } from "../../shared/components/footer/footer.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    TranslateModule,
    FooterComponent,
  ],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.scss",
})
export class ForgotPasswordComponent {
  public forgotPasswordForm: FormGroup;
  subscriptions: Subscription[] = [];
  passwordTemporary: any;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  sendEmail() {
    if (this.forgotPasswordForm.valid) {
      const email = { email: this.forgotPasswordForm.value["email"] };
      this.authService.resetPassword(email).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.passwordTemporary = res.data.temporaryPassword;
            const successMessage = this.translateService.instant('forgot_password.message_password_tmp')
            const checkYourEmail = this.translateService.instant('forgot_password.check_your_email')
            this.toastrService.success(checkYourEmail, successMessage);
            this.router.navigate(["/auth"])
          }
        },
        error: (err: any) => {
          if (err.error.message) {
          }
        },
        complete: () => {},
      });
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }
}
